import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";

i18next
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("locale") || "en",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    backend: {
      loadPath: "/{{ns}}/messages.{{lng}}.json",
      customHeaders: {
        "Cache-Control": "no-cache",
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
  });

export default i18next;
